module.exports = __webpack_public_path__ + "fonts/Montserrat-ThinItalic.5ba39d1f.ttf";